export enum WelcomeStep {
	forgotPassword = 'forgotPassword',
	resetPassword = 'resetPassword',
}
